import React, {useState} from 'react'
import PropTypes from 'prop-types'

// Project Components
import {
    AccordionItem,
    AccordionButton,
    AccordionIcon,
    Heading,
    Drawer,
    DrawerBody,
    DrawerHeader,
    DrawerOverlay,
    DrawerContent,
    DrawerCloseButton
} from '@salesforce/retail-react-app/app/components/shared/ui'

const CategoryLinks = ({category = {}}) => {
    const {categories = []} = category
    const [isDrawerOpen, setIsDrawerOpen] = useState(false)
    const [selectedCategory, setSelectedCategory] = useState(null)

    const openDrawer = (category) => {
        setSelectedCategory(category)
        setIsDrawerOpen(true)
    }

    const closeDrawer = () => {
        setIsDrawerOpen(false)
        setSelectedCategory(null)
    }

    return (
        <>
            {categories.map(({id, name, categories}) => (
                <AccordionItem paddingBottom={6} borderTop="none" key={id}>
                    <AccordionButton data-testid={`category-accordion-button-${id}`} onClick={() => openDrawer({id, name, categories})}>
                        <Heading as="h2" flex="1" textAlign="left" fontSize="md" fontWeight={600}>
                            {name}
                        </Heading>
                        <AccordionIcon />
                    </AccordionButton>
                </AccordionItem>
            ))}

            <Drawer
                placement="right"
                isOpen={isDrawerOpen}
                onClose={closeDrawer}
                size="sm"
                motionPreset="slideInRight"
            >
                <DrawerOverlay />
                <DrawerContent>
                    <DrawerCloseButton />
                    <DrawerHeader>{selectedCategory?.name}</DrawerHeader>
                    <DrawerBody>
                        {selectedCategory?.categories &&
                            selectedCategory?.categories?.map(({id, name, categories}) => (
                                <AccordionItem paddingBottom={6} borderTop="none" key={id}>
                                    <AccordionButton
                                        data-testid={`category-drawer-accordion-button-${id}`}
                                        onClick={() => openDrawer({id, name, categories})}
                                    >
                                        <Heading
                                            as="h2"
                                            flex="1"
                                            textAlign="left"
                                            fontSize="md"
                                            fontWeight={600}
                                        >
                                            {name}
                                        </Heading>
                                        <AccordionIcon />
                                    </AccordionButton>
                                </AccordionItem>
                            ))}
                    </DrawerBody>
                </DrawerContent>
            </Drawer>
        </>
    )
}

CategoryLinks.propTypes = {
    category: PropTypes.object
}

export default CategoryLinks
